module.exports = __webpack_public_path__ + "static/media/furniture2.81b6c167.jpg";